import { StateCreator } from 'zustand';
import {
  IKioskAppointmentsFields,
  IKioskAppointmentsSlice,
  TKioskStore,
} from './type';
import { appointmentsApi } from '@/API';

const initState: IKioskAppointmentsFields = {
  kioskAppointments: [],
};

export const kioskAppointmentsSlice: StateCreator<
  TKioskStore,
  [],
  [],
  IKioskAppointmentsSlice
> = (set) => ({
  ...initState,
  getAppointmentsKiosk: async () => {
    try {
      const result = await appointmentsApi.getAppointmentsKiosk();
      const kioskAppointments = result.data.data.sort(
        (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
      );
      set({ kioskAppointments });
      return kioskAppointments;
    } catch (error) {
      console.warn(error);
      set({ kioskAppointments: [] });
    }
  },
});
